import React, { useState, useRef, useEffect } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { TbPointFilled } from "react-icons/tb";
import PageLoader from "../../components/ui/Loader/PageLoader";
import styles from "../../style/Pages/ClearLogs.module.css";
import { getRegisterId } from "../../utils/authId";
import { useCompanyDatas } from "../../hooks/UseFilter";
import {
  useDeleteChatGet,
  useDeleteHistory,
  useDeleteUpdate,
} from "../../hooks/useDeleteChat";
import Button from "../../components/ui/buttons/Button";
import DeletionConfirm from "../../components/ui/Warning/DeletionConfirm";
import Loader from "../../components/ui/Loader/Loader";

const History = () => {
  const topRef = useRef(null);
  const register_id = getRegisterId();
  const [timeRange, setTimeRange] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [errorsDele, setErrorsDele] = useState({});

  const [showAlert, setShowAlert] = useState(false);
  const [chatDeleteAccess, setChatDeleteAccess] = useState(false); // New state for chat delete access

  // const companies = useCompanyFilter();
  const { isloading: loading, companies } = useCompanyDatas();
  const { loading: isLoadingDelete, deleteData } = useDeleteChatGet();

  useEffect(() => {
    if (errorMessage || (errors?.response_error?.length ?? 0) > 0) {
      topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [errorMessage, errors]);

  const isCategorySelected = (category) =>
    selectedCategories.includes(category);

  const isCompanySelected = (category) => selectedCompany.includes(category);

  const handleTimeRangeChange = (e) => {
    const value = e.target.value;
    setTimeRange(value);

    const currentDate = new Date();
    let from, to;

    switch (value) {
      case "last_day":
        from = new Date(currentDate.setDate(currentDate.getDate() - 1));
        to = new Date();
        break;
      case "today":
        from = new Date();
        to = new Date();
        break;
      case "last_week":
        from = new Date(currentDate.setDate(currentDate.getDate() - 7));
        to = new Date();
        break;
      case "last_month":
        from = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
        to = new Date();
        break;
      case "last_year":
        from = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
        to = new Date();
        break;
      case "custom":
        from = "";
        to = "";
        break;
      case "all_data":
        // Select all company filters when "All Data" is selected
        const allCompanies = companies
          .filter((company) => company.value !== "")
          .map((company) => company.name || company.value || company.id);
        setSelectedCategories(allCompanies);
        return;
      default:
        from = "";
        to = "";
    }

    setFromDate(from ? from.toISOString().split("T")[0] : "");
    setToDate(to ? to.toISOString().split("T")[0] : "");
  };

  const handleErrors = (error) => {
    console.log(error);
    const newErrors = {
      response_error: [],
    };
    if (error.response && error.response.data) {
      const errorData = error.response.data.data;
      for (const key in errorData) {
        if (errorData.hasOwnProperty(key)) {
          newErrors.response_error.push(errorData[key]);
        }
      }
    } else {
      newErrors.response_error.push("An unexpected error occurred.");
    }

    setErrors(newErrors);
  };
  const handleErrorsComp = (error) => {
    console.log(error);
    const newErrors = {
      response_error: [],
    };
    if (error.response && error.response.data) {
      const errorData = error.response.data.data;
      for (const key in errorData) {
        if (errorData.hasOwnProperty(key)) {
          newErrors.response_error.push(errorData[key]);
        }
      }
    } else {
      newErrors.response_error.push("An unexpected error occurred.");
    }

    setErrorsDele(newErrors);
  };

  const handleCheckboxChangeCat = (e) => {
    const { value, checked } = e.target;
    const parsedValue = isNaN(value) ? value : Number(value);
    if (checked) {
      setSelectedCategories((prev) => [...prev, parsedValue]);
    } else {
      setSelectedCategories((prev) =>
        prev.filter((category) => category !== parsedValue)
      );
    }
  };

  useEffect(() => {
    const fetchDeleteAccessData = async () => {
      try {
        // Assuming deleteData is the API response that contains the structure you provided
        if (deleteData) {
          const companyIds = Array.isArray(deleteData.company_id)
            ? deleteData.company_id.map((id) => Number(id))
            : [];

          setSelectedCompany(companyIds); // Set chat delete access from API response
          setChatDeleteAccess(deleteData.delete_access || false);
        }
      } catch (error) {
        console.error("Error fetching delete access data:", error);
      }
    };

    fetchDeleteAccessData();
  }, [deleteData]);

  const handleCheckboxChangeCompany = (e) => {
    console.log(selectedCompany);
    const { value, checked } = e.target;
    const parsedValue = isNaN(value) ? value : Number(value);
    if (checked) {
      setSelectedCompany((prev) => [...prev, parsedValue]);
    } else {
      setSelectedCompany((prev) =>
        prev.filter((category) => category !== parsedValue)
      );
    }
  };

  const validateForm = () => {
    if (!timeRange) {
      setErrorMessage("Please select a time range.");
      return false;
    }
    if (timeRange !== "all_data" && selectedCategories.length === 0) {
      setErrorMessage("Please select at least one Company to delete.");
      return false;
    }
    if (timeRange === "custom" && new Date(fromDate) > new Date(toDate)) {
      setErrorMessage("From date cannot be later than To date.");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const closePopup = () => {
    setShowAlert(false);
  };
  const { isLoading, ClearLogs } = useDeleteHistory();
  const { isUpdating, UpdateDel } = useDeleteUpdate();
  const handleDelete = () => {
    if (!validateForm()) return;

    setShowAlert(true);

    // Here you would typically make an API call to delete the data

    // Add your API call here, for example:
  };

  const handleUpdatedData = async () => {
    closePopup();

    const payload = {
      user_id: register_id,
    };
    if (timeRange === "all_data") {
      payload.all_data = timeRange;
      payload.company_id = selectedCategories;
    } else {
      payload.company_id = selectedCategories;
      payload.from_date = fromDate;
      payload.to_date = toDate;
    }
    try {
      await ClearLogs(payload);
      // Reset form after successful deletion
      setTimeRange("");
      setFromDate("");
      setToDate("");
      setSelectedCategories([]);
      setErrorMessage("");
      setErrors({});
    } catch (error) {
      handleErrors(error);
    }
  };

  const handleChatDeleteAccessToggle = () => {
    setChatDeleteAccess(!chatDeleteAccess);
  };

  const handleUpdated = async () => {
    const payload = {
      user_id: register_id,
      company_id: selectedCompany,
      delete_access: chatDeleteAccess,
    };

    try {
      await UpdateDel(payload);
      // Reset form after successful deletion
    } catch (error) {
      handleErrorsComp(error);
    }
  };
  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p>History</p>
        </div>
      </div>
      <div className={mainStyle.mainContentView} style={{ height: "92%" }}>
        {loading ? (
          <PageLoader />
        ) : (
          <div className={mainStyle.mainContentViewsb}>
            <div style={{ width: "60%" }}>
              <div className={styles.formSection}>
                {errorMessage && (
                  <div className={styles.errorMessage}>{errorMessage}</div>
                )}

                {errors.response_error && (
                  <div className={styles.errorMessage}>
                    {errors.response_error.join(" ")}
                  </div>
                )}
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Time Range</label>
                  <select
                    className={styles.formSelect}
                    value={timeRange}
                    onChange={handleTimeRangeChange}
                  >
                    <option value="">Select time range</option>
                    <option value="all_data">All Data</option>
                    <option value="today">Today</option>
                    <option value="last_day">Last 2 Days</option>
                    <option value="last_week">Last 7 Days</option>
                    <option value="last_month">Last Month</option>
                    <option value="last_year">Last Year</option>
                    <option value="custom">Custom Date Range</option>
                  </select>
                </div>

                {timeRange === "custom" && (
                  <div className={styles.dateRangeGroup}>
                    <div className={styles.formGroup}>
                      <label className={styles.formLabel}>From Date</label>
                      <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className={styles.formInput}
                      />
                    </div>
                    <div className={styles.formGroup}>
                      <label className={styles.formLabel}>To Date</label>
                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className={styles.formInput}
                      />
                    </div>
                  </div>
                )}

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Select Company</label>
                  <div className={styles.categoryGrid}>
                    {companies
                      .filter((company) => company.value !== "")
                      .map((company) => {
                        // Assuming structure: { value: 3, label: "Mathangi" }
                        const companyValue = company.value;
                        const displayName = company.label || "Unknown Company";

                        return (
                          <label
                            key={companyValue}
                            className={`${styles.categoryItem} ${
                              isCategorySelected(companyValue)
                                ? styles.categoryItemSelected
                                : ""
                            }`}
                          >
                            <input
                              type="checkbox"
                              value={companyValue}
                              checked={isCategorySelected(companyValue)}
                              onChange={handleCheckboxChangeCat}
                              className={styles.categoryCheckbox}
                            />
                            <span className={styles.categoryName}>
                              {displayName}
                            </span>
                          </label>
                        );
                      })}
                  </div>
                </div>

                {/* Delete Button */}
                <div className={styles.formGroup}>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <Button onClick={handleDelete} variant={"danger"}>
                      {isLoading ? <Loader /> : "Submit"}
                    </Button>
                  </div>
                </div>

                <div className={styles.notesSection}>
                  <h4 className={styles.notesTitle}>Important Notes:</h4>
                  <div className={styles.notesGrid}>
                    <div className={styles.noteItem}>
                      <TbPointFilled className={styles.noteIcon} />
                      <span>Deleted history cannot be recovered</span>
                    </div>
                    <div className={styles.noteItem}>
                      <TbPointFilled className={styles.noteIcon} />
                      <span>Large deletions may take several minutes</span>
                    </div>
                    <div className={styles.noteItem}>
                      <TbPointFilled className={styles.noteIcon} />
                      <span>
                        System performance may be affected during deletion
                      </span>
                    </div>
                    <div className={styles.noteItem}>
                      <TbPointFilled className={styles.noteIcon} />
                      <span>
                        Recommended to perform deletions during off-peak hours
                      </span>
                    </div>
                  </div>
                </div>

                {errorsDele.response_error && (
                  <div className={styles.errorMessage}>
                    {errorsDele.response_error.join(" ")}
                  </div>
                )}
                <div className={styles.additionalContent}>
                  <div className={styles.formGroup}>
                    <div className={styles.switchContainer}>
                      <label className={styles.switchLabel}>
                        Chat Delete Access
                      </label>
                      <div className={styles.switchDescription}>
                        Allow users to delete their own chat messages
                      </div>
                      <label className={styles.toggleSwitch}>
                        <input
                          type="checkbox"
                          checked={chatDeleteAccess}
                          onChange={handleChatDeleteAccessToggle}
                          className={styles.switchInput}
                        />
                        <span className={styles.slider}></span>
                      </label>
                    </div>

                    <div className={styles.formGroup}>
                      <label className={styles.formLabel}>Select Company</label>
                      <div className={styles.categoryGrid}>
                        {companies
                          .filter((company) => company.value !== "")
                          .map((company) => {
                            // Assuming structure: { value: 3, label: "Mathangi" }
                            const companyValue = company.value;
                            const displayName =
                              company.label || "Unknown Company";

                            return (
                              <label
                                key={companyValue}
                                className={`${styles.categoryItem} ${
                                  isCompanySelected(companyValue)
                                    ? styles.categoryItemSelected
                                    : ""
                                }`}
                              >
                                <input
                                  type="checkbox"
                                  value={companyValue}
                                  checked={isCompanySelected(companyValue)}
                                  onChange={handleCheckboxChangeCompany}
                                  className={styles.categoryCheckbox}
                                />
                                <span className={styles.categoryName}>
                                  {displayName}
                                </span>
                              </label>
                            );
                          })}
                      </div>
                    </div>
                    <div className={styles.formGroup}>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <Button onClick={handleUpdated} variant={"danger"}>
                          {isUpdating ? <Loader /> : "Submit"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Success Alert Modal */}
      {showAlert && (
        <DeletionConfirm
          onClose={() => setShowAlert(false)}
          onSucess={handleUpdatedData}
        />
      )}
    </MainLayout>
  );
};

export default History;
